import React from "react";

const ErrorModal = ({
  show = true,
  onClose,
  onConfirm,
  title,
  errors = [],
  type, // "error" or "warning"
}) => {
  console.log("errors", errors);
  console.log("type error", type);
  const config = {
    error: {
      icon: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#ef4444"
          strokeWidth="2"
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M15 9l-6 6M9 9l6 6" />
        </svg>
      ),
      color: "#ef4444",
      bgColor: "#fee2e2",
      gradient: "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
      title: title || "Validation Error",
    },
    warning: {
      icon: (
        <svg
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#f59e0b"
          strokeWidth="2"
        >
          <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
      ),
      color: "#f59e0b",
      bgColor: "#fef3c7",
      gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
      title: title || "Warning",
    },
  };

  const currentConfig = config[type] || config.error;

  return (
    <>
      {/* Backdrop */}
      <div
        className="position-fixed top-0 start-0 w-100 h-100"
        style={{
          //   background: "rgba(0, 0, 0, 0.5)",
          //   backdropFilter: "blur(4px)",
          zIndex: 1050,
          animation: "fadeIn 0.3s ease",
        }}
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="position-fixed top-50 start-50 translate-middle"
        style={{
          zIndex: 1051,
          width: "90%",
          maxWidth: "500px",
          //   animation: "slideDown 0.3s ease",
        }}
      >
        <div
          className="bg-white rounded-4 shadow-lg overflow-hidden"
          style={{
            border: `2px solid ${currentConfig.color}`,
          }}
        >
          {/* Header with Gradient */}
          <div
            className="p-4 position-relative overflow-hidden"
            style={{
              background: currentConfig.gradient,
            }}
          >
            {/* Decorative circles */}
            <div
              className="position-absolute"
              style={{
                width: "120px",
                height: "120px",
                background: "rgba(255, 255, 255, 0.1)",
                borderRadius: "50%",
                top: "-40px",
                right: "-30px",
              }}
            ></div>
            <div
              className="position-absolute"
              style={{
                width: "80px",
                height: "80px",
                background: "rgba(255, 255, 255, 0.08)",
                borderRadius: "50%",
                bottom: "-20px",
                left: "10%",
              }}
            ></div>

            <div className="d-flex align-items-center gap-3 position-relative">
              {/* <div
                className="bg-white rounded-3 d-flex align-items-center justify-content-center"
                style={{
                  width: "64px",
                  height: "64px",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                }}
              >
                {currentConfig.icon}
              </div> */}
              <div className="flex-grow-1">
                <h5 className="text-white fw-bold mb-1">
                  {currentConfig.title}
                </h5>
                <p className="text-white-50 mb-0 small">
                  {type === "error"
                    ? "Please fix the following issues to continue"
                    : "Please review the following warnings"}
                </p>
              </div>
              <button
                onClick={onClose}
                className="btn-close btn-close-white"
                style={{
                  opacity: 0.8,
                }}
              />
            </div>
          </div>

          {/* Body */}
          <div
            className="p-4"
            style={{ maxHeight: "400px", overflowY: "auto" }}
          >
            {errors.length > 0 ? (
              <div className="d-flex flex-column gap-3">
                {errors.map((error, index) => (
                  <div
                    key={index}
                    className="rounded-3 p-3 position-relative"
                    style={{
                      background: `${currentConfig.bgColor}`,
                      border: `1px solid ${currentConfig.color}30`,
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "translateX(5px)";
                      e.currentTarget.style.boxShadow = `0 4px 12px ${currentConfig.color}40`;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "translateX(0)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <div className="d-flex gap-3">
                      {/* Error Number Badge */}
                      <div
                        className="rounded-circle d-flex align-items-center justify-content-center fw-bold flex-shrink-0"
                        style={{
                          width: "32px",
                          height: "32px",
                          background: currentConfig.color,
                          color: "white",
                          fontSize: "0.85rem",
                        }}
                      >
                        {index + 1}
                      </div>

                      {/* Error Details */}
                      <div className="flex-grow-1">
                        <h6
                          className="fw-bold mb-2"
                          style={{ color: currentConfig.color }}
                        >
                          {error.itemName || "Unknown Item"}
                          {error.sku && (
                            <span
                              className="badge bg-light text-dark ms-2 fw-normal"
                              style={{ fontSize: "0.7rem" }}
                            >
                              SKU: {error.sku}
                            </span>
                          )}
                        </h6>

                        <p
                          className="mb-2 text-dark"
                          style={{ fontSize: "0.9rem" }}
                        >
                          {error.message}
                        </p>

                        {/* Stock Information */}
                        {(error.currentStock !== undefined ||
                          error.requestedQty !== undefined) && (
                          <div className="row g-2 mt-2">
                            {error.currentStock !== undefined && (
                              <div className="col-6">
                                <div className="bg-white rounded-2 p-2 text-center">
                                  <small
                                    className="text-muted d-block"
                                    style={{ fontSize: "0.7rem" }}
                                  >
                                    Available Stock
                                  </small>
                                  <span
                                    className="fw-bold text-success d-block"
                                    style={{ fontSize: "1.1rem" }}
                                  >
                                    {error.currentStock}
                                  </span>
                                </div>
                              </div>
                            )}
                            {error.requestedQty !== undefined && (
                              <div className="col-6">
                                <div className="bg-white rounded-2 p-2 text-center">
                                  <small
                                    className="text-muted d-block"
                                    style={{ fontSize: "0.7rem" }}
                                  >
                                    Requested Qty
                                  </small>
                                  <span
                                    className="fw-bold d-block"
                                    style={{
                                      fontSize: "1.1rem",
                                      color: currentConfig.color,
                                    }}
                                  >
                                    {error.requestedQty}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        {/* Shortage Warning */}
                        {error.shortage && (
                          <div
                            className="rounded-2 p-2 mt-2 d-flex align-items-center gap-2"
                            style={{
                              background: "white",
                              border: `1px solid ${currentConfig.color}`,
                            }}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke={currentConfig.color}
                              strokeWidth="2"
                            >
                              <path d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                            </svg>
                            <small
                              className="fw-semibold"
                              style={{ color: currentConfig.color }}
                            >
                              Short by: {error.shortage} units
                            </small>
                          </div>
                        )}

                        {/* Remaining Stock Info (for warnings) */}
                        {error.remainingStock !== undefined && (
                          <div
                            className="rounded-2 p-2 mt-2 d-flex align-items-center gap-2"
                            style={{
                              background: "white",
                              border: `1px solid ${currentConfig.color}`,
                            }}
                          >
                            <svg
                              width="16"
                              height="16"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke={currentConfig.color}
                              strokeWidth="2"
                            >
                              <path d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <small
                              className="fw-semibold"
                              style={{ color: currentConfig.color }}
                            >
                              Remaining after approval: {error.remainingStock}{" "}
                              units
                            </small>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-4">
                <p className="text-muted mb-0">
                  No{" "}
                  {type === "error"
                    ? "errors"
                    : type === "error2"
                      ? "errors"
                      : "warnings"}{" "}
                  to display
                </p>
              </div>
            )}
          </div>

          {/* Footer */}
          <div className="p-4 bg-light border-top">
            <div className="d-flex justify-content-end gap-2">
              <button
                onClick={onClose}
                className="btn btn-lg rounded-3 px-4"
                style={{
                  background: currentConfig.color,
                  color: "white",
                  border: "none",
                  fontWeight: "600",
                  transition: "all 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-2px)";
                  e.currentTarget.style.boxShadow = `0 4px 12px ${currentConfig.color}60`;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                {type === "error"
                  ? "Got it"
                  : type === "error2"
                    ? "Got it"
                    : "Close"}
              </button>
              {type === "error" ? (
                ""
              ) : type === "error2" ? (
                ""
              ) : (
                <button
                  onClick={onConfirm}
                  className="btn btn-lg rounded-3 px-4"
                  style={{
                    background: "#82c14a",
                    color: "white",
                    border: "none",
                    fontWeight: "600",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow = `0 4px 12px ${currentConfig.color}60`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  Confirm
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Animations */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translate(-50%, -60%);
          }
          to {
            opacity: 1;
            transform: translate(-50%, -50%);
          }
        }
      `}</style>
    </>
  );
};

export default ErrorModal;
